import { createApi } from "@reduxjs/toolkit/dist/query/react"
import { API_MARKET_URL } from "constants/config"
import { authBaseQuery } from "services/api"

if (!API_MARKET_URL) {
  throw new Error("REACT_APP_API_MARKET_URL is not defined")
}

export const marketpricesApi = createApi({
  reducerPath: "marketpricesApi",
  baseQuery: authBaseQuery(API_MARKET_URL),
  tagTypes: [
    "Report",
    "GorpReports",
    "ReportObs",
    "PriceDataSummary",
    "Outliers",
    "OutliersGetByValue",
    "OutliersList",
    "MappingSchema",
    "DataCollectionFreq",
    "Projects",
    "Forms",
    "LastFetchData",
    "FetchOperations",
    "XlsFormMappings",
    "XlsFormFieldsWithGroups",
    "BaseXlsForm",
    "BaseSchemas",
    "XlsFormQuestionList",
    "ReportStatus",
    "XlsForm",
    "PriceDataSummary",
    "LastFetchData",
    "FetchOperations",
  ],
  endpoints: () => ({}),
})
